
export default function BalanceCard() {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-6 text-white mb-6 shadow-lg">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-blue-100 text-sm">الرصيد الإجمالي</p>
          <h2 className="text-3xl font-bold">125,450.00 ر.س</h2>
        </div>
        <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
          <i className="ri-wallet-line text-2xl"></i>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-blue-500/30">
        <div>
          <p className="text-blue-100 text-xs">التحويلات اليوم</p>
          <p className="text-lg font-semibold">15,200 ر.س</p>
        </div>
        <div>
          <p className="text-blue-100 text-xs">العمولات المحققة</p>
          <p className="text-lg font-semibold">2,340 ر.س</p>
        </div>
      </div>
    </div>
  );
}
